(function () {
  'use strict';

  var STORAGE_KEY = 'wishlist';
  var changeListenerAttached = false;

  // Translations injected from Liquid via data-wishlist-i18n in theme.liquid
  var i18nEl = document.querySelector('[data-wishlist-i18n]');
  var T_ADD = i18nEl ? i18nEl.dataset.tAdd : 'Add to wishlist';
  var T_REMOVE = i18nEl ? i18nEl.dataset.tRemove : 'Remove from wishlist';
  var T_VIEW = i18nEl ? i18nEl.dataset.tViewProduct : 'View product';
  var T_ATC = i18nEl ? i18nEl.dataset.tAtc : 'Add to cart';
  var T_SOLD_OUT = i18nEl ? i18nEl.dataset.tSoldOut : 'Sold out';

  // Cache badge element — it lives in the header and is never removed
  var badge = document.querySelector('[data-wishlist-count]');

  function getHandles() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; }
  }

  function setHandles(handles) {
    try {
      var deduped = Array.from(new Set(handles)).slice(0, 100);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(deduped));
      return deduped;
    } catch (e) { return handles; }
  }

  function toggle(handle) {
    var handles = getHandles();
    var idx = handles.indexOf(handle);
    var saved = idx === -1;
    if (saved) { handles.push(handle); } else { handles.splice(idx, 1); }
    var persisted = setHandles(handles);
    updateButtons(handle, persisted.indexOf(handle) !== -1);
    updateBadge(persisted.length);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle: handle, saved: saved } }));
  }

  function updateButtons(handle, saved) {
    document.querySelectorAll('[data-wishlist-toggle="' + handle + '"]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(saved));
      btn.setAttribute('aria-label', saved ? T_REMOVE : T_ADD);
    });
  }

  function refresh() {
    var handles = getHandles();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var saved = handles.indexOf(btn.dataset.wishlistToggle) !== -1;
      btn.setAttribute('aria-pressed', String(saved));
      btn.setAttribute('aria-label', saved ? T_REMOVE : T_ADD);
    });
    updateBadge(handles.length);
  }

  function updateBadge(count) {
    if (!badge) return;
    if (count === undefined) count = getHandles().length;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function renderWishlistPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var productCache = {};

    function fetchAndRender() {
      var handles = getHandles();
      grid.hidden = true;
      empty.hidden = true;

      if (handles.length === 0) {
        empty.hidden = false;
        return;
      }

      var remaining = handles.length;

      handles.forEach(function (handle) {
        if (productCache[handle] !== undefined) {
          remaining--;
          if (remaining === 0) renderGrid(handles);
          return;
        }
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) { productCache[handle] = p; })
          .catch(function () { productCache[handle] = null; })
          .finally(function () {
            remaining--;
            if (remaining === 0) renderGrid(handles);
          });
      });
    }

    function renderGrid(handles) {
      var html = '';
      handles.forEach(function (handle) {
        var p = productCache[handle];
        if (!p) return;

        // featured_image from /products/handle.js is an object {src, width, height} or null
        var rawSrc = p.featured_image ? p.featured_image.src : '';
        // Insert _400x size param before extension, preserving ?v= query string
        var imgSrc = rawSrc ? rawSrc.replace(/(\.[^.?]+)(\?|$)/, '_400x$1$2') : '';
        var price = formatMoney(p.price);
        var cmpPrice = p.compare_at_price > p.price ? formatMoney(p.compare_at_price) : '';

        html += '<div class="product-card">';
        html += '<a href="/products/' + handle + '" class="product-card__link">';
        html += '<div class="product-card__image-wrapper">';
        if (imgSrc) {
          html += '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(p.title) + '"'
            + ' loading="lazy" class="product-card__image product-card__image--primary" width="400" height="400">';
        }
        html += '</div>';
        html += '<h2 class="product-card__title">' + escapeHtml(p.title) + '</h2>';
        html += '<div class="product-card__price">';
        if (cmpPrice) html += '<span class="product-card__price--compare">' + cmpPrice + '</span> ';
        html += price + '</div>';
        html += '</a>';
        html += '<button type="button"'
          + ' class="btn btn--outline product-card__wishlist wishlist-btn wishlist-btn--saved"'
          + ' data-wishlist-toggle="' + escapeHtml(handle) + '"'
          + ' aria-pressed="true"'
          + ' aria-label="' + escapeHtml(T_REMOVE) + '">'
          + heartSVG()
          + ' <span class="wishlist-btn__label">' + escapeHtml(T_REMOVE) + '</span>'
          + '</button>';
        if (!p.available) {
          html += '<button type="button" class="btn btn--primary product-card__add-to-cart" disabled>'
            + escapeHtml(T_SOLD_OUT) + '</button>';
        } else if (p.variants.length > 1) {
          html += '<a href="/products/' + escapeHtml(handle) + '" class="btn btn--primary product-card__add-to-cart">'
            + escapeHtml(T_VIEW) + '</a>';
        } else {
          html += '<button type="button"'
            + ' class="btn btn--primary product-card__add-to-cart"'
            + ' data-wishlist-atc'
            + ' data-variant-id="' + p.variants[0].id + '">'
            + escapeHtml(T_ATC) + '</button>'
            + '<p class="cart-error" data-wishlist-atc-error role="alert"></p>';
        }
        html += '</div>';
      });

      if (html) {
        grid.innerHTML = html;
        grid.hidden = false;
      } else {
        empty.hidden = false;
      }
    }

    fetchAndRender();

    // Guard against listener accumulation if renderWishlistPage is ever called again
    if (!changeListenerAttached) {
      changeListenerAttached = true;
      document.addEventListener('wishlist:change', fetchAndRender);
    }
  }

  function heartSVG() {
    return '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"'
      + ' stroke="currentColor" stroke-width="2" aria-hidden="true">'
      + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06'
      + 'a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06'
      + 'a5.5 5.5 0 0 0 0-7.78z"/>'
      + '</svg>';
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(String(str)));
    return d.innerHTML;
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var handle = toggleBtn.dataset.wishlistToggle;
      if (handle) toggle(handle);
      return;
    }

    var atcBtn = e.target.closest('[data-wishlist-atc]');
    if (!atcBtn) return;
    var variantId = atcBtn.dataset.variantId;
    if (!variantId) return;
    atcBtn.disabled = true;
    var errorEl = atcBtn.parentNode.querySelector('[data-wishlist-atc-error]');
    if (errorEl) errorEl.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (result) {
        atcBtn.disabled = false;
        if (!result.ok) {
          if (errorEl) {
            errorEl.textContent = (result.data && result.data.description)
              ? result.data.description
              : window.theme && window.theme.strings && window.theme.strings.cartAddError
                ? window.theme.strings.cartAddError
                : 'Impossible d\'ajouter cet article.';
          }
          return;
        }
        if (window.CartDrawer) {
          window.CartDrawer.open();
        } else {
          window.location = '/cart';
        }
      })
      .catch(function () {
        atcBtn.disabled = false;
        if (errorEl) errorEl.textContent = 'Impossible d\'ajouter cet article.';
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    renderWishlistPage();
  });

  // Exposed for quick-view to call after injecting product HTML
  window.Wishlist = { refresh: refresh };

})();
